import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import axios from 'axios'; // or you can use fetch



const UnsubFormOnly: FC = () => {
    const router = useRouter();
    const [email, setEmail] = useState(''); // State for email

    // Set the default message when the `visitor` parameter is available


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // Read every named field straight off the form, post server-side -> email.
        const payload: any = Object.fromEntries(new FormData(e.target as HTMLFormElement) as any);
        payload.source = payload['form-name'] || 'Website form';
        delete payload['bot-field'];
        try {
            const response = await axios.post('/api/submit-form', payload);
            if (response.status === 200) {
                router.push('/thanks');
            } else {
                console.error('Failed to send message');
            }
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    return (
        <form name="Unsubscribe" method="post" onSubmit={handleSubmit}>
            <input type="hidden" name="form-name" value="Unsubscribe" />
            <p className="d-none">
                <label>
                    <input name="bot-field" />
                </label>
            </p>
            <div className="row gx-4">
                <div className="col-md-6" style={{ margin: "0 auto" }}>
                    <div className="form-floating mb-4">
                        <input
                            required
                            type="email"
                            name="email"
                            id="form_email"
                            className="form-control"
                            placeholder=""
                            value={email}
                            onChange={(e) => setEmail(e.target.value)} // Update email state
                        />
                        <label htmlFor="form_email">Email *</label>
                        <div className="valid-feedback">Looks good! </div>
                        <div className="invalid-feedback">Please provide a valid email address. </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <input type="submit" value="Unsubscribe" className="btn btn-primary btn-send mb-3 d-inline-block" style={{ width: 200 }} />
                </div>
            </div>
        </form>
    );
};

export default UnsubFormOnly;